import React from "react";

const VaultTab = () => {
  return <div>VaultTab</div>;
};

export default VaultTab;
